import React, { useEffect, useState } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { Col, Container, Row } from 'reactstrap'
import { getNewDealerCountHierarchy } from '../../../constants/apiCalls'
import { BreadCrumbBackButton } from '../../Breadcrumbs/BreadCrumbBackButton'
import { Breadcrumbs } from '../../Breadcrumbs/Breadcrumbs'
import { DealerCard } from '../../Card'
import CustomSpinner from '../../CustomSpinner/CustomSpinner'
import { DashBoardTitle } from '../../Title';
import Storage from "../../../services/Storage";
import ModalService from '../../../services/ModalService';
import { handleErrorMessage } from '../../../../src/utils/utils';
import './index.css';
import { messages } from '../../../utils/constant-messages'
import { Permissions } from '../../../constants/Permissions'
import { useSelector } from 'react-redux'
import AppHeader from '../../../Layout/AppHeader'
import AppSidebar from '../../../Layout/AppSidebar'

export const ApproveSHCard = () => {
    const navigate = useNavigate();
    // const localPermission = Storage.getUserPermissionDetail();
    const { permissionArr } = useSelector(state => state.UserGetReducer)
    const localPermission = permissionArr;
    const params = useParams();
    let location = useLocation();
    let userInfo = Storage.getUserInfoDetail();
    let userId = userInfo ? userInfo.id : null;
    let paramId = params.id ? params.id : userId;
    let userDataAll = Storage.getBreadcrumbsrRecord();
    useEffect(() => {
        if (!localPermission.includes(Permissions.APPROVED_APP)) {
            navigate('/');
        }
    }, [...localPermission])

    const [approveData, setApproveData] = useState([])
    const [isLoading, setIsloading] = useState(false);
    const [isSameUser, setIsSameUser] = useState(true);

    useEffect(() => { Storage.removeAppprovePage() }, [])

    useEffect(() => {
        setIsloading(true)
        if (isSameUser) {
            getApproveData(paramId)
        }
    }, [paramId, location.title])

    const getApproveData = (id) => {
        const sameParamIndex = userDataAll && userDataAll.length ? userDataAll.findIndex(x => x.url === location.pathname) : -1;
        let own = true;
        if (sameParamIndex > -1 && userDataAll[userDataAll.length - 1].filter.id === userDataAll[sameParamIndex].filter.id) {
            own = false;
        }
        let lastuser = userDataAll && userDataAll.length > 0 ? userDataAll[userDataAll.length - 1] : {};
        let newDealerType = {
            type: 'approve',
            id: params.id ? params.id : '',
            date: Storage.getDashboardCurrentDate() ? Storage.getDashboardCurrentDate() : '',
            own,
            state_id: lastuser && lastuser.filter && lastuser.filter.state_id && lastuser.filter.state_id !== 0 ? lastuser.filter.state_id : '',
        }
        getNewDealerCountHierarchy(res => {
            const { data, success, error } = res
            if (success) {
                const index = data && data.length ? data.findIndex(x => x.id === +paramId) : -1;
                if (index > -1) {
                    let sameCardData = data[index];
                    let role = data[index].role;
                    if (sameCardData && sameCardData.role === 'NH') {
                        role = "SH";
                    } else if (sameCardData && sameCardData.role === 'SH') {
                        role = "TM";
                    }
                    sameCardData.role = role;
                    data[index] = sameCardData;

                }
                setApproveData(data)
                setIsloading(false);
            } else if (success === false || success === 'undefined') {
                setIsloading(false);
                ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
            }
            setIsloading(false);
        }, newDealerType)

    }

    const handleTitleClick = (cardData) => {
        setIsloading(true)

        if (cardData.id && paramId && (cardData.id === +paramId)) {
            setIsSameUser(false)
            let newDealerType = {
                type: 'approve',
                id: cardData.id ? cardData.id : '',
                date: Storage.getDashboardCurrentDate() ? Storage.getDashboardCurrentDate() : '',
                own: false,
                state_id: cardData.state_id && cardData.state_id !== 0 ? cardData.state_id : '',
            }
            getNewDealerCountHierarchy(res => {
                const { data, success, error } = res
                if (success) {
                    const index = data && data.length ? data.findIndex(x => x.id === +cardData.id) : -1;
                    if (index > -1) {
                        let sameCardData = data[index];
                        let role = data[index].role;
                        if (sameCardData && sameCardData.role === 'NH') {
                            role = "SH";
                        } else if (sameCardData && sameCardData.role === 'SH') {
                            role = "TM";
                        }
                        sameCardData.role = role;
                        data[index] = sameCardData;

                    }
                    setApproveData(data)
                    setIsloading(false);
                    setIsSameUser(true)
                } else if (success === false || success === 'undefined') {
                    setIsloading(false);
                    ModalService.openAlert('', handleErrorMessage(error[0].message), 'error');
                }
                setIsloading(false);
            }, newDealerType)
        }

        Storage.setBreadcrumbsrRecord([
            {
                title: `${cardData.role}: ${cardData.first_name || ""} ${cardData.last_name || ""}`,
                url: location.pathname,
                filter: cardData
            },

        ]);
        navigate({ pathname: `/pages/approved-app-summary/${cardData.id}`, title: `(${cardData.role}) ${cardData.first_name || ""} ${cardData.last_name || ""}` });
        setIsloading(false);

    }

    const handleCountClick = (cardData) => {
        setIsloading(true)
        Storage.setBreadcrumbsrRecord([
            {
                title: `${cardData.role}: ${cardData.first_name || ""} ${cardData.last_name || ""}`,
                url: location.pathname,
                filter: cardData
            },

        ]);
        navigate({ pathname: `/pages/approved-app/${cardData.id}`, title: `(${cardData.role}) ${cardData.first_name || ""} ${cardData.last_name || ""}` });
        setIsloading(false);
    }

    return (
        <>
            <AppHeader />
            <div className='app-main'>
                <AppSidebar />
                <div className='app-main__outer'>
                    <div className='app-main__inner rms-wrapper'>
                        <div id='approveSHCard'>
                            {isLoading && <CustomSpinner />}
                            <div className='pageWrapper'>
                                <Container fluid>
                                    <Row>
                                        <Col xs={12}>
                                            <div className='pageheader'>
                                                <DashBoardTitle dashBorardName="New Dealer Pipeline" />
                                                <BreadCrumbBackButton />
                                            </div>
                                        </Col>
                                        <Col xs={12}>
                                            <Breadcrumbs />
                                        </Col>
                                    </Row>
                                    {!approveData.length && !isLoading ? (
                                        <Row>
                                            <Col xs={12}>
                                                {messages.COMMON.NO_RECORD_FOUND}
                                            </Col>
                                        </Row>
                                    ) : (
                                        <div className='approveCardWrapper'>
                                            <Row>
                                                {approveData.map((elem, index) => {
                                                    return (
                                                        <Col xl={4} lg={6} md={6} key={index}>
                                                            <DealerCard
                                                                cardData={elem}
                                                                handleTitleClick={() => handleTitleClick(elem)}
                                                                handleCountClick={() => handleCountClick(elem)}
                                                            />
                                                        </Col>
                                                    )
                                                })}
                                            </Row>
                                        </div>
                                    )}
                                </Container>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}